/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMigrationQueryRequest
 */
export interface UserMigrationQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryRequest
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryRequest
     */
    password?: string | null;
}

/**
 * Check if a given object implements the UserMigrationQueryRequest interface.
 */
export function instanceOfUserMigrationQueryRequest(value: object): value is UserMigrationQueryRequest {
    return true;
}

export function UserMigrationQueryRequestFromJSON(json: any): UserMigrationQueryRequest {
    return UserMigrationQueryRequestFromJSONTyped(json, false);
}

export function UserMigrationQueryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationQueryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'username': json['username'] === undefined ? undefined : json['username'] === null ? null : json['username'],
        'password': json['password'] === undefined ? undefined : json['password'] === null ? null : json['password'],
    };
}

export function UserMigrationQueryRequestToJSON(json: any): UserMigrationQueryRequest {
    return UserMigrationQueryRequestToJSONTyped(json, false);
}

export function UserMigrationQueryRequestToJSONTyped(value?: UserMigrationQueryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'username': value['username'],
        'password': value['password'],
    };
}

